import React, {useState} from 'react'
import {useHistory} from 'react-router-dom'

import CssBaseline from '@material-ui/core/CssBaseline'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography'
import { makeStyles} from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import BootstrapButton from './Common/BootstrapButton'
import {login} from '../services/api'
import {ILoginRequestParams} from '../interfaces/api'
import {Alert} from '@material-ui/lab'
import BootstrapInput from './Common/BootstrapInput'
import {Backdrop, CircularProgress} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.dark,
    },
    paper: {
        height: '100vh',
        paddingTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1)
    },
    submit: {
        backgroundColor: '#256081',
        color: 'white',
        borderRadius: '10px',
        padding: "10px 10px",
        marginTop: theme.spacing(3),
        // display: 'flex',
        margin: 'auto',
        fontSize: '1.5em',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
}))

export default function SignIn() {
    const classes = useStyles()
    const history = useHistory()

    const handleLoggedIn = () => {
        history.push('/step')
    }
    const [loading, setLoading] = useState<boolean>(false)

    const [error, setError] = useState<string[]>([])
    const [userInfo, setUserInfo] = useState<ILoginRequestParams>({
        email: '',
        password: '',
        session_id: '',
    })

    const handleSubmit = async () => {
        setError([])
        setLoading(true)

        const response = await login(userInfo)

        if (response.data.errors) {
            if (response.data.errors.length > 0) {
                setError(
                    response.data.errors.map((item: any, idx: number) => {
                        return <span key={idx}>{item.message}</span>
                    })
                )
            } else {
                setError(response.data.message)
            }
            setLoading(false)

            return
        } else {
            setLoading(false)
            console.info('Logging')
            sessionStorage.setItem('token', response.data.token)
            sessionStorage.setItem('expires', response.data.expires)
            handleLoggedIn()
        }
    }

    return (
        <Container component="main" maxWidth="xs" className={classes.root}>
            <CssBaseline/>

            <Backdrop
                style={{zIndex: 100}}
                sx={(theme) => ({ color: '#fff', zIndex: 100 })}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className={classes.paper}>
                <form className={classes.form} noValidate>
                    <Typography align="center">
                        Please enter your username and password.
                    </Typography>
                    <br/>
                    <Grid item xs={12}>
                        {error && error.length ? (
                            <Alert severity="error">{error}</Alert>
                        ) : (
                            ''
                        )}
                    </Grid>
                    <br/>
                    <FormControl fullWidth>
                        <InputLabel style={{color:'#000'}} shrink htmlFor="bootstrap-input">
                            Email Address
                        </InputLabel>
                        <BootstrapInput
                            defaultValue="react-bootstrap"
                            id="bootstrap-input"
                            value={userInfo.email}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setUserInfo({
                                    ...userInfo,
                                    email: e.currentTarget.value,
                                })
                            }/>
                    </FormControl>
                    <br/>
                    <br/>
                    <FormControl fullWidth>
                        <InputLabel style={{color:'#000'}} shrink htmlFor="bootstrap-input">
                            Password
                        </InputLabel>
                        <BootstrapInput
                            name="password"
                            type="password"
                            id="bootstrap-input"
                            value={userInfo.password}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setUserInfo({
                                    ...userInfo,
                                    password: e.currentTarget.value,
                                })
                            }/>
                    </FormControl>
                    <br/>
                    <div style={{textAlign: "center", width:"auto",  bottom: 0, margin: "20px 0px"}}>
                        <BootstrapButton
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={handleSubmit}>
                            Sign In
                        </BootstrapButton>
                        <br/>
                        <br/>
                        <br/>
                        <Grid container>
                            <Grid item>
                                <Link style={{color:'#000'}} href="/register" variant="body2">
                                    {"Don't have an account? Click here to register."}
                                </Link>
                            </Grid>
                            <br/>
                            <br/>
                            <Grid container>
                                <Grid item>
                                    <Link  style={{color:'#000'}} href="/forgot">
                                        {"Forgot Password."}
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </form>
            </div>
        </Container>
    )
}
